import React from 'react';
import { CustomModalLayout, Modal, Text } from '@wix/design-system';
import type { ManagedApp } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
import { useTranslation } from '../../../hooks/use-translation';

export function UpdateModal({
  app,
  msId,
  closeModal,
  openCompleteUpdateInEditor,
}: {
  app: ManagedApp;
  msId: string;
  openCompleteUpdateInEditor(appId: string): void;
  closeModal(): void;
}) {
  const t = useTranslation();
  const appId = app?.appId || '';
  const appName = app?.appInfo?.name?.replace('&amp;', '&');
  const trnaslatedTitle: string = t(
    'manage-apps.update-from-editor-modal-title',
    { name: appName },
  );
  const title = trnaslatedTitle.replace('&amp;', '&').replace('&#x2F;', '/');

  const onGoToEditorClick = () => {
    openCompleteUpdateInEditor(appId);
    closeModal();
  };

  const onCloseClick = () => {
    closeModal();
  };

  return (
    <Modal isOpen>
      <CustomModalLayout
        width="510px"
        title={title}
        dataHook="update-editor-app-from-bm-modal"
        primaryButtonText={t(
          'manage-apps.update-from-editor-modal-primary-button',
        )}
        primaryButtonOnClick={onGoToEditorClick}
        secondaryButtonText={t(
          'manage-apps.update-from-editor-modal-secondary-button',
        )}
        secondaryButtonOnClick={onCloseClick}
        onCloseButtonClick={onCloseClick}
      >
        <Text>{t('manage-apps.update-from-editor-modal-content')}</Text>
      </CustomModalLayout>
    </Modal>
  );
}
